import request from "../../request";
export const getAllEvents = async date => {
  let events = await request(
    {},
    `/api/renddite/GetAllRendDite?$filter=dataOra lt ${date.add(1, 'days').toISOString()} and dataOra gt ${date.subtract(1, "days").toISOString()}&$expand=struktura`,
    "index"
  );
  return events;
};
export const getPikaById = async id => {
  let pika = await request(
    {},
    `/api/pikarendi/GetPikaRendiByRendDiteID/` + id,
    "index"
  );
  return pika;
};
export const changeLogs = [
  {
    id: 1,
    title: "Initial Release",
    date: "Jan 21, 2019",
    logs: [
      {
        description: "Initial release version 1.3"
      }
    ]
  },
  {
    id: 2,
    title: "V-1.4 ",
    date: "Jan 22, 2019",
    logs: [
      {
        type: "add",
        description: "Added 2 Starter Templates"
      }
    ]
  },
  {
    id: 3,
    title: "V-1.5 ",
    date: "Jan 26, 2019",
    logs: [
      {
        description: "Updated to CRA-2"
      }
    ]
  }
];
